// pages/ApiDocs.jsx
import React, { useState } from 'react'
import {Box, Stack, styled, Tab, Tabs, Typography} from '@mui/material'
import BasePage from '../../baseComponents/BasePage'
import ApiEndpointInstance from "./ApiEndpointInstance";
import {endpoints} from "../../../utils/apiEndpoints";
import {BASENAME, VERSION, APIKEY} from "../../../utils/api";
import {CustomLink} from "./About";
import ApiDemonstrations from "./ApiDemonstrations";
import Button from "@mui/material/Button";

const EndpointHeader = styled(Typography)(({ theme }) => ({
  fontWeight: 'bolder',
  color: theme.palette.blues.rothko2,
  fontSize: 'medium'
}));

const EndpointCode = styled(Typography)(({ theme }) => ({
  fontWeight: 'bolder',
  // color: theme.palette.blues.rothko2,
  fontSize: 'large',
  fontFamily: 'monospace',
}));

const SectionText = styled(Typography)(({ theme }) => ({
  color: theme.palette.base.rothko4,
  fontSize: 'small',
}));

const ApiDocs = () => {
  const [tab, setTab] = useState(0)
  return (
    <BasePage>
      <Box width={'100%'} display={'flex'} justifyContent={'center'}>
        <Tabs
          value={tab}
          onChange={(_, i) => setTab(i)}
          aria-label="API Documentation Tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{ mt: 3, mb:1, zIndex: 10 }}
        >
          <Tab key={0} label={"Authorization"}/>
          {endpoints.map((ep, i) => (
            <Tab key={i+1} label={ep.title} />
          ))}
          <Tab key={endpoints.length + 1} label={"Examples"}/>
        </Tabs>
      </Box>

      <Box
        width={'100%'}
        sx={{
          borderRadius: '8px',
          bgcolor: 'white',
          boxShadow: `
            inset 6px 6px 8px rgba(0, 0, 0, 0.3),
            inset -6px -6px 8px rgba(255, 255, 255, 0.5)
          `,
        }}
      >
        <div key={0} role="tabpanel" hidden={tab !== 0}>
          <Box sx={{ p: 3 }}>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'max-content 1fr',
                rowGap: 1,
                columnGap: 1,
                mb: '24px',
              }}
            >
              <EndpointHeader component="div">Host</EndpointHeader>
              <EndpointCode component="div" sx={{fontSize: {xs: 'medium', sm: 'large'}}}>{BASENAME}</EndpointCode>

              <EndpointHeader component="div">Base Path</EndpointHeader>
              <EndpointCode component="div" sx={{fontSize: {xs: 'medium', sm: 'large'}}}>{`/v${VERSION}/api`}</EndpointCode>

              <EndpointHeader component="div">Authorization</EndpointHeader>
              <EndpointCode component="div" sx={{fontSize: {xs: 'medium', sm: 'large'}}}>{`Api-Key ${APIKEY}`}</EndpointCode>
            </Box>
            <Stack>
              <SectionText sx={{ mb: 2 }}>
                Welcome to the <b>MHDweb Data Access API</b>. This interface provides:
              </SectionText>
              <SectionText sx={{ mb: 2 }}>
                <ul>
                  <li>Programmatic retrieval of MAS run HDF5 data files</li>
                  <li>Querying of the <i>MAS Run Database</i> and <i>Spacecraft Database</i></li>
                  <li>Generation of <i>Time Series Comparisons</i> and <i>Spacecraft Mapping</i> data products</li>
                </ul>
              </SectionText>
              <SectionText sx={{ mb: 0 }}>
                This API is designed for scientists and developers who wish to integrate MHDweb's capabilities into their research or applications.
                To request access, click the link below. Once approved, you will receive an API key through the email you provided;
                include this key within the <b><code>Authorization</code></b> header of each request (using the format provided above).
              </SectionText>
              <Button
                variant={'contained'}
                color={'secondary'}
                component="a"
                href="https://predsci.com/mhdweb2/api_signup/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  width: {xs: '100%', sm: '250px'},
                  marginTop: 2,
                  alignSelf: 'center',
                  fontSize: 'small'
                }}
              >
                REQUEST API KEY
              </Button>
              </Stack>
          </Box>
        </div>
        {endpoints.map((ep, i) => (
          <div key={i+1} role="tabpanel" hidden={i+1 !== tab}>
            {i+1 === tab && <ApiEndpointInstance {...ep} />}
          </div>
        ))}
        <div key={endpoints.length + 1} role="tabpanel" hidden={tab !== endpoints.length + 1}>
          <ApiDemonstrations />
        </div>
      </Box>
    </BasePage>
  )
}

export default ApiDocs
